module.exports = __webpack_public_path__ + "img/gestao-lotes-lista-vazia.ff0ed808.svg";